enum EntityType {
  DOSSIER = 'dossierAttachment',
  JOB = 'job',
  WHEELS = 'wheels',
  OBJECT_SLA = 'objectstla',
  CONTACT_SLA = 'contactsla',
  DRIVE_BOOKING = 'drivebooking',
}

export default EntityType;